const BORDER_WIDTH = 2;
const PADDING_X = 10;
const PADDING_Y = 5;

const COLORS = {
    WHITE: {
        BG_TINT: 0xffffff,
        BORDER_TINT: 0x000000,
    }
};

export default class BG extends Phaser.GameObjects.Container {
    private border!: Phaser.GameObjects.Image;
    private bg!: Phaser.GameObjects.Image;
    private bgTint: number;
    private borderTint: number;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        const { BG_TINT, BORDER_TINT } = COLORS["WHITE"];
        this.bgTint = BG_TINT;
        this.borderTint = BORDER_TINT;

        this.setupBorder();
        this.setupBG();
    }

    private setupBorder(): void {
        this.border = this.scene.add.image(0, 0, 'atlas', 'blank');
        // this.border.setDisplaySize(width + BORDER_WIDTH * 2, height + BORDER_WIDTH * 2);
        this.border.setTint(this.borderTint);
        this.add(this.border);
    }

    private setupBG(): void {
        this.bg = this.scene.add.image(0, 0, 'atlas', 'blank');
        // this.bg.setDisplaySize(width, height);
        this.bg.setTint(this.bgTint);
        this.add(this.bg);
    }

    public updateSize(bounds: Phaser.Types.GameObjects.BitmapText.LocalBitmapTextSize): void {
        const borderWidth = bounds.width + BORDER_WIDTH * 2 + PADDING_X * 2;
        const borderHeight = bounds.height + BORDER_WIDTH * 2 + PADDING_Y * 2;

        const bgWidth = bounds.width + PADDING_X * 2;
        const bgHeight = bounds.height + PADDING_Y * 2;

        this.border.setDisplaySize(borderWidth, borderHeight);
        this.bg.setDisplaySize(bgWidth, bgHeight);
    }

    public getTopLeft(): { x: number; y: number } {
        return { x: -this.bg.displayWidth / 2, y: -this.bg.displayHeight / 2 };
    }
}
